import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CookiesService } from './services/cookies.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, HttpClientModule],
})
export class SeoModule {
    static forRoot(config): ModuleWithProviders<SeoModule> {
        return {
            ngModule: SeoModule,
            providers: [
                { provide: CookiesService, useClass: config.server8Service }
            ],
        };
    }
}
